import { Controller } from '@hotwired/stimulus';

export default class AscensusSamlController extends Controller<HTMLFormElement> {
  connect() {
    this.element.requestSubmit();
  }
}
